import script from "./countdown-clock.vue?vue&type=script&lang=js"
export * from "./countdown-clock.vue?vue&type=script&lang=js"

import "./countdown-clock.vue?vue&type=style&index=0&id=4cd22608&lang=scss"

const __exports__ = script;

export default __exports__